<template>
	<div class="wrapper">

		<!-- Preloader -->
		<div v-if="loading" class="preloader flex-column justify-content-center align-items-center">
			<img class="animation__shake" src="@/assets/logo.png" height="60" width="60">
		</div>

		<!-- Navbar -->
		<nav class="main-header navbar navbar-expand navbar-dark navbar-light">
			<!-- Left navbar links -->
			<ul class="navbar-nav">
				<li class="nav-item">
					<a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
				</li>
				<li class="nav-item dropdown">
					<router-link to="/mine/generals" class="nav-link" data-toggle="dropdown" aria-haspopup="true"
						aria-expanded="false">概览</router-link>
				</li>
				<el-popover placement="top-start" title="分析模型" width="300" trigger="hover">
					<li slot="reference" class="nav-item dropdown">
						<router-link to="/analysis" class="nav-link" data-toggle="dropdown" aria-haspopup="true"
							aria-expanded="false">分析模型</router-link>
					</li>
					<el-empty description="请选择分析模型">
						<img slot="image" src="@/assets/logo.png" class="brand-image img-circle elevation-3"
							style="width: 64px;opacity: .8">
						<el-row type="flex" justify="center">
							<el-col :span="8">
								<router-link to="/analysis/count" class="btn btn-app bg-secondary">
									<i class="fas fa-dice"></i> 动态数字
								</router-link>
							</el-col>
							<el-col :span="8">
								<router-link to="/analysis/property" class="btn btn-app bg-secondary">
									<i class="fas fa-wave-square"></i> 属性分析
								</router-link>
							</el-col>
							<el-col :span="8">
								<router-link to="/analysis/columnToRow" class="btn btn-app bg-secondary">
									<i class="fas el-icon-s-operation"></i> 列转行分析
								</router-link>
							</el-col>
						</el-row>
					</el-empty>
				</el-popover>

				<li class="nav-item d-none d-sm-inline-block">
					<router-link to="/mine/analysis" class="nav-link">书签</router-link>
				</li>

				<li class="nav-item d-none d-sm-inline-block" v-if="hasOneAuthoritiy('ROLE_ADMIN')">
					<router-link to="/system/meta" class="nav-link">元数据</router-link>
				</li>

				<li class="nav-item d-none d-sm-inline-block" v-if="node_env === 'development'">
					<router-link to="/test" class="nav-link">测试</router-link>
				</li>
			</ul>

			<!-- Right navbar links -->
			<ul class="navbar-nav ml-auto">
				<li class="nav-item">
					<a class="nav-link" data-widget="fullscreen" href="#" role="button">
						<i class="fas fa-expand-arrows-alt"></i>
					</a>
				</li>
				<li class="nav-item" v-if="isSigned">
					<a class="nav-link" @click="sidebarVisited=true" data-slide="true" href="#" role="button">
						{{ username }}
					</a>
				</li>
				<li class="nav-item" v-else>
					<el-tooltip placement="bottom-start">
						<template #content>
							<p class="login-box-msg">请登录您的会话</p>
							<el-form size="mini" :disabled="loading" label-position="top" label-width="80px"
								:model="ruleForm" :rules="rules" ref="ruleForm">
								<el-form-item label="用户名" prop="username">
									<el-input v-model="ruleForm.username" placeholder="用户名" suffix-icon="el-icon-user">
									</el-input>
								</el-form-item>
								<el-form-item label="密码" prop="password">
									<el-input v-model="ruleForm.password" type="password" placeholder="密码"
										suffix-icon="el-icon-lock">
									</el-input>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" @click="submitForm('ruleForm')" :loading="loading">登录
									</el-button>
								</el-form-item>
							</el-form>
						</template>
						<a class="nav-link" data-slide="true" href="#" role="button">
							登录
						</a>
					</el-tooltip>
				</li>
			</ul>
		</nav>
		<!-- /.navbar -->

		<router-view :key="routerViewKey" />

		<footer class="main-footer">
			<div class="d-none d-sm-inline-block thi-part"><span>安徽开放大学版权所有</span><span class="sp1"><a href="">皖ICP备05003560-4号</a></span></div>
			<div class="float-right d-none d-sm-inline-block thi-part"><span>技术支持：学业云 &nbsp; 服务电话：400-012-6228</span><span><b>版本</b> {{version}}</span></div>
		</footer>

		<el-drawer v-if="isSigned" :visible.sync="sidebarVisited" :with-header="false" :size="250"
			custom-class="dark-mode">
			<!-- Control Sidebar -->
			<!-- Control sidebar content goes here -->
			<!-- Widget: user widget style 1 -->
			<div class="card card-widget widget-user">
				<!-- Add the bg color to the header using any of the bg-* classes -->
				<div class="widget-user-header text-white bg-adminlte-photo1">
					<h3 class="widget-user-desc text-right">欢迎，{{ username }}</h3>
					<h5 class="widget-user-username text-right">
						<el-popconfirm @confirm="logoutHandler" title="您确定要退出登录吗？" confirmButtonText='确定'
							cancelButtonText='取消'>
							<template #reference>
								<el-button type="text">注销登录</el-button>
							</template>
						</el-popconfirm>
					</h5>
				</div>
				<div class="widget-user-image">
					<img class="img-circle" :src="photo" alt="User Avatar" v-if="photo">
					<img class="img-circle" src="@/assets/avatar.png" alt="User Avatar" v-else>
				</div>
				<div class="card-footer">
				</div>
				<div class="card-footer p-0">
					<ul class="nav flex-column">
						<li class="nav-item">
							<router-link to="/mine/generals" class="nav-link">
								我的概览 <span class="float-right badge bg-primary">{{ mine_general_total }}</span>
							</router-link>
						</li>
						<li class="nav-item">
							<router-link to="/mine/analysis" class="nav-link">
								我的书签
							</router-link>
						</li>
						<li class="nav-item">
							<router-link to="/mine/clients" class="nav-link">
								我的客户端 <span class="float-right badge bg-success">{{ mine_client_total }}</span>
							</router-link>
						</li>
					</ul>
				</div>
			</div>
		</el-drawer>

	</div>
	<!-- ./wrapper -->
</template>

<script>
	/* global */
	import $ from 'jquery'
	import {
		mapActions,
		mapGetters
	} from 'vuex'

	export default {
		data() {
			return {
				node_env: process.env.NODE_ENV,
				version: process.env.VUE_APP_VERSION,
				loading: true,
				sidebarVisited: false,
				ruleForm: {
					username: '',
					password: ''
				},
				rules: {
					username: [{
							required: true,
							message: '请输入用户名',
							trigger: 'blur'
						},
						{
							min: 4,
							max: 20,
							message: '长度在 4 到 20 个字符',
							trigger: 'blur'
						}
					],
					password: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							min: 4,
							max: 20,
							message: '长度在 4 到 20 个字符',
							trigger: 'blur'
						}
					],
				}
			}
		},

		created() {},

		mounted() {
			$('body').attr('class',
				'hold-transition dark-mode sidebar-mini layout-fixed layout-navbar-fixed layout-footer-fixed')
			this.loading = false
		},

		computed: {
			routerViewKey() {
				// 默认情况下 key 类似 __transition-n-/foo
				// 这里的字符串操作是为了最终 key 的格式和原来相同 类似 __transition-n-__stamp-time-/foo
				const stamp = this.$route.meta[`__stamp-${this.$route.path}`] || ''
				return `${stamp ? `__stamp-${stamp}-` : ''}${this.$route.path}`
			},
			...mapGetters('system/account', [
				'username', 'photo', 'isSigned', 'hasOneAuthoritiy'
			]),
			...mapGetters('mine/generals', ['mine_general_total']),
			...mapGetters('mine/clients', ['mine_client_total']),
		},

		methods: {
			...mapActions('system/account', [
				'login', 'logout'
			]),
			logoutHandler() {
				this.loading = true
				this.logout()
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.loading = true
						this.login({
								username: this.ruleForm.username,
								password: this.ruleForm.password,
							})
							.then(() => {
								this.loading = false
								this.$router.replace(this.$route.query.redirect || this.$route.fullPath)
								this.sidebarVisited = true
							})
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
		}
	}
</script>
<style>
	.el-form--label-top .el-form-item__label {
		display: none;
	}

	.control-sidebar {
		right: -350px;
		width: 350px;
	}

	.bg-adminlte-photo1 {
		background: url('~admin-lte/dist/img/photo1.png') center center
	}
	.thi-part span {
		padding-right: 12px;
	}
	.thi-part .sp1 {
	    background: url(http://hbedu.hblll.com//img/footer-icon05.1fdd2885.png) 0 no-repeat;
	    padding-left: 32px;
	}
</style>
